module.exports = __webpack_public_path__ + "resources/images/screen1-379b55e6bb963b4c0abdcd5d3c8630c5-cache.png";